import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {HelpComponent} from '../help/help.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DndModule} from 'ng2-dnd';
import {MomentModule} from 'angular2-moment';
import {PromptModalComponent} from './prompt-modal/prompt-modal.component';
import {FolderComponent} from "../storyboard/storyboard-list/folder/folder.component";
import {CreateFolderComponent} from "../storyboard/storyboard-list/create-folder/create-folder.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DragulaModule} from "ng2-dragula";
import {MediaLibraryService} from "../media-library/shared/media-library.service";
import {NgUploaderModule} from "ngx-uploader";
import {RouterModule} from "@angular/router";
import {ReversePipe} from "../pipes/reverse.pipe";
import { ShareModalComponent } from './share-modal/share-modal.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import {SortPipe} from "../pipes/sort.pipe";
import {ClipboardModule} from "ngx-clipboard";

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    MomentModule,
    FormsModule,
    ReactiveFormsModule,
    NgUploaderModule,
    RouterModule,
    ClipboardModule
  ],
  declarations: [HelpComponent, FolderComponent, CreateFolderComponent, PromptModalComponent, ReversePipe, ShareModalComponent, ToggleSwitchComponent, SortPipe],
  exports: [
    CommonModule,
    NgbModule,
    DndModule,
    DragulaModule,
    TranslateModule,
    HelpComponent,
    MomentModule,
    FolderComponent,
    CreateFolderComponent,
    PromptModalComponent,
    NgUploaderModule,
    RouterModule,
    ReversePipe,
    SortPipe,
    ClipboardModule,
    ShareModalComponent,
    ToggleSwitchComponent
  ],
  providers: [MediaLibraryService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts